import React, {useEffect} from 'react'
import { Outlet } from 'react-router-dom'
import Banner from '../components/Banner'
import FooterNavCompatibles from '../components/FooterNavCompatibles'
import Logo from "../assets/iconos/logo-icon.png"
import useAuth from '../hooks/useAuth'
import { listado_etiquetas } from '../services/public/Public'
import {obtenerLabelEtiqueta} from '../utils/idioma/LabelsIdioma'
import useProcesoMatricula from '../hooks/useProcesoMatricula'
import ModalLoading from '../components/ModalLoading'



const Auth = () => {
  const {listadoIdiomas,seleccionIdiomas,setSeleccionIdiomas,setListadoEtiquetas,loadingAuth} = useAuth();
  const {setLoading,loading} = useProcesoMatricula();
  
  
 

  let handleSeleccionIdioma = async (e) =>{

      
      localStorage.setItem("idioma", e.target.value);
      
      setSeleccionIdiomas(localStorage.getItem("idioma"));

      try {
        
         listado_etiquetas(e.target.value,setListadoEtiquetas,setLoading);

      } catch (error) {
        setLoading(false);
      }
      finally{
        setLoading(false);
      }
      

  }

  return (
    
    <>
      <div className="container-md login ">
        <div className="row vh-95 va-middle" >
            <div className="card vh-80 shadow">
              <div className="row">
                <Banner />
                <div className="col-md-6 col-lg-6 col-sm-12 px-0">
                    <div className="login-header d-flex">
                      <img src={Logo} />
                      <h5>
                        PORTAL DE <br /> MATRÍCULA
                      </h5>
                    </div>
                    <div className="config-lang">
                      <i className="far fa-globe red-primary"></i>
                      <select value={seleccionIdiomas}  className="form-select form-select-sm select-lang" onChange={handleSeleccionIdioma}>
                      {listadoIdiomas && listadoIdiomas.map((idioma)=>{
                        let {cidioma,ddescripcion} = idioma
                        return (
                          <option key={cidioma} value={cidioma}>{ddescripcion}</option>
                        )
                      })}
                         
                      </select>
                    </div>
                    <Outlet />
                </div>
                
              </div>
              {loading && (
              <ModalLoading />
              )}
              {loadingAuth && (
              <ModalLoading />
              )}
              <FooterNavCompatibles />
            </div>
         </div>
      </div>
      
      <div className="footer fixed">
        <div>
            <p>©2022 Universidad Peruana Cayetano Heredia</p>
        </div>
      </div>
    </>
  )
}

export default Auth